
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// pages for use in router:
import App from './components/App.vue';

//global components
import Tinput from './components/inputs/Tinput.vue';
import Countdown from './components/inputs/Countdown.vue';
import Avatar from './components/partials/Avatar.vue';
import CKEditor from './components/inputs/CKEditor.vue';
import EmailMessage from './components/inputs/EmailMessage.vue';
import Datetime from './components/inputs/Datetime.vue';

//import jQuery from 'jquery';

//global.jQuery = $ = window.$ = window.jQuery = require('jquery');
let moment = require('moment');
global.moment = moment;
require("../vendor/tempusdominus/tempusdominus-bootstrap-3.min");
require('promise-shim');
require('es5-shim');

import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import VueRouter from 'vue-router';

import VideoPlayer from './components/widgets/VideoPlayer.vue';
import VideoInput from './components/inputs/Video.vue';
import Breadcrumbs from './components/widgets/Breadcrumbs.vue';

Vue.prototype.$http = axios;

Vue.use(VueRouter);
Vue.use(Vuex);

Vue.component('ckeditor', CKEditor);
Vue.component('email-message', EmailMessage);
Vue.component('tinput', Tinput);
Vue.component('countdown', Countdown);
Vue.component('avatar', Avatar);
Vue.component('datetime', Datetime);
Vue.component('video-player', VideoPlayer);
Vue.component('video-input', VideoInput);
Vue.component('breadcrumbs', Breadcrumbs);

!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '429425823917765');

const store = new Vuex.Store({
    modules: {
        i18n: vuexI18n.store
    }
});

Vue.use(vuexI18n.plugin, store);

import es from './translations/es.js'

Vue.i18n.add('es', es);
/*
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});*/

jQuery(function($) { $.extend({
    form: function(url, data, method) {
        if (method == null) method = 'POST';
        if (data == null) data = {};

        let form = $('<form>').attr({
            method: method,
            action: url
        }).css({
            display: 'none'
        });

        let addData = function(name, data) {
            if ($.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    var value = data[i];
                    addData(name + '[' + i + ']', value);
                }
            } else if (typeof data === 'object') {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        addData(name + '[' + key + ']', data[key]);
                    }
                }
            } else if (data != null) {
                form.append($('<input>').attr({
                    type: 'hidden',
                    name: String(name),
                    value: String(data)
                }));
            }
        };
        addData("_token", $('meta[name="csrf-token"]').attr('content'));

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                addData(key, data[key]);
            }
        }

        return form.appendTo('body');
    }
}); });

//Vue.http.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');

const bus = new Vue();

window.bus = bus;

axios.interceptors.response.use(undefined,
    function (error) {
        if (error.response.status === 422) {
            if (typeof error.response.data == 'object') {
                for (let field in error.response.data.errors) {
                    if(error.response.data.errors.hasOwnProperty(field))
                    {
                        error.response.data.errors[field].forEach(message => {
                            app.bus.$emit("notify", {
                                message: message,
                                type: "danger",
                                timeout: 5000,
                                escape: true
                            });
                        });
                    }
                }
            }
        } else if (error.response.status === 401 ||
                   error.response.status === 403 ||
                   error.response.status === 419) {
            window.location = '/login';
        } else {
            bus.$emit("notify", {message: "An unknown error occurred. Please try reloading the page with F5.", type: "danger", timeout: 0});
        }

        return Promise.reject(error);
    }
);

import routes from './routes.js';
if(typeof window.application != 'undefined')
{
    Vue.i18n.set(window.application.language);
}

const router = new VueRouter({
    routes,
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: "active",
    scrollBehavior: function(to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        } else if(to.name == from.name) {
            return false;
        }
        else {
            return { x: 0, y: 0 }
        }
    },
});

router.beforeEach(function(to, from, next) {
    if(to.params.locale === undefined || (to.params.locale !== 'en' && to.params.locale !== 'es'))
    {
        let locale = Vue.i18n.locale();
        if(locale == null)
        {
            locale = 'en';
            Vue.i18n.set(locale);
        }

        next('/' + locale + to.fullPath);
        return;
    }
    else
    {
        Vue.i18n.set(to.params.locale);
    }


    let permission = to.meta.permission;
    if(!(typeof(window.application.user.acl.permissions[permission]) != 'undefined' && window.application.user.acl.permissions[permission]))
    {
        window.fullPath = to.fullPath;
        next('/login');
    }
    else
    {
        fbq('track', 'PageView');
        next();
    }
});

router.afterEach(function(to, from) {
    Vue.config.locale = to.params.locale;
});

let mixin = {
    methods: {
        $url(base) {
            return '/' + Vue.i18n.locale() + '/' + base;
        },
        $sort(array, prop, dir) {

            if(typeof array == 'object')
            {
                let newArray = [];
                for(let i in array)
                {
                    if(array.hasOwnProperty(i))
                    {
                        newArray.push(array[i]);
                    }
                }
                array = newArray;
            }

            if(typeof prop == 'undefined')
            {
                prop = 'title';
            }

            if(typeof dir == 'undefined' || (dir != 'asc' && dir != 'desc') || dir == 'asc')
            {
                dir = 1;
            }
            else
            {
                dir = -1;
            }

            if(typeof prop == 'function')
            {
                return array.sort(function(a,b) {
                    let aVal = prop(a);
                    let bVal = prop(b);
                    if($.isNumeric(aVal) && $.isNumeric(bVal)) {
                        if(dir === 1) return aVal - bVal;
                        return bVal - aVal;
                    } else {
                        if (aVal == bVal) return 0;
                        if (aVal > bVal) return dir;
                        return -dir;
                    }
                });
            }
            else
            {
                return array.sort(function(a,b) {
                    let aVal = a[prop];
                    let bVal = b[prop];
                    if($.isNumeric(aVal) && $.isNumeric(bVal)) {
                        if(dir === 1) return aVal - bVal;
                        return bVal - aVal;
                    } else {
                        if (aVal == bVal) return 0;
                        if (aVal > bVal) return dir;
                        return -dir;
                    }
                });
            }
        },
        $fbq: fbq,
        $allowed(permission) {
            return (typeof(this.$root.app.user.acl.permissions[permission]) != 'undefined' && this.$root.app.user.acl.permissions[permission]);
        },
        $notify(message, type, timeout)
        {
            this.$root.bus.$emit("notify", {
                message: message,
                type: type,
                timeout: timeout
            });
        },
        $alert(confirm, options) {
            if(typeof options == 'undefined')
            {
                options = {};
            }

            if(typeof confirm == 'undefined')
            {
                confirm = null;
            }

            this.$root.bus.$emit('alert-modal:open', {confirm_callback: confirm, options: options});
        },
        $confirm(confirm, cancel, options) {
            if(typeof options == 'undefined')
            {
                options = {};
            }

            if(typeof cancel == 'undefined')
            {
                cancel = null;
            }

            if(typeof confirm == 'undefined')
            {
                confirm = null;
            }

            this.$root.bus.$emit('confirmation-modal:open', {confirm_callback: confirm, cancel_callback: cancel, options: options});
        },
    }
};

Vue.mixin(mixin);

const app = new Vue({
    router,
    data: {app: window.application, bus: bus},
    components: {app: App}
}).$mount('#app');
